<template>
    <div class="courses-single-page bg-dark-blue" style="overflow-y: auto;">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="content-page-wrap clearfix">
                        <div class="course-single">
                            <div class="container-fluid">
                                <div class="content">
                                    <div class="card mt-3 mb-3">
                                        <div class="container-fluid">

                                            <div class="d-flex justify-content-between align-items-end">

                                                <div class="title m-2 text-dark-blue">
                                                    Sites
                                                </div>
                                                <router-link to="/admin/sites/0">
                                                    <div class="btn-add-alt p-2">
                                                        New Site
                                                    </div>
                                                </router-link>
                                            </div>
                                            <div class="table-reasponsive">

                                                <table class="table" style="overflow-y:scroll; display:table; max-height: 600px;">
                                                    <thead>
                                                        <tr>
                                                            <td>Name</td>
                                                            <td class="td-200">Domains</td>
                                                            <td>From Email</td>
                                                            <td>Paygate Id</td>
                                                            <td>Courses</td>
                                                            <td></td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="site in sites" class="align-items-center">
                                                            <td>{{ site.name}}</td>
                                                            <td class="td-200">{{ site.domains}}</td>
                                                            <td>{{ site.fromEmail }}</td>
                                                            <td>{{ site.paygateId }}</td>
                                                            <td>
                                                                <div class="courses">
                                                                    <select>
                                                                        <option v-for="course in site.courses" value="value">
                                                                            {{course.name}}
                                                                        </option>
                                                                        <option v-if="site.courses && site.courses.length < 1">
                                                                            No courses yet!
                                                                        </option>
                                                                    </select>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="d-flex align-items-center">
                                                                    <router-link :to="{ name: 'AdminSitesDetails', params: { id: site.id }}">
                                                                        <div class="btn-add-alt-2 p-2">
                                                                            Edit
                                                                        </div>
                                                                    </router-link>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div><!-- courses-single -->
</template>

<style>
    .course {
        border-bottom: 1px solid black;
    }

    .td-200 {
        max-width: 300px;
    }
</style>

<script>
    export default {
        name: 'AdminSites',
        data: function () {
            return {
                sites: [],
                courses: []
            }
        },
        props: {

        },
        methods: {
        },
        async mounted() {
            //load courses
            this.sites = await this.web("/sites?roles=admin&filters=none", "Loading sites");
            var crumbs = {};
            crumbs["/admin/sites"] = "Sites";
            this.$store.commit("breadCrumbs", crumbs);
        }
    }
</script>
